export default [
  {
    title: 'Sales',
    icon: 'ShoppingCartIcon',
    children: [
      {
        title: 'Sales Submissions (Changi)',
        route: 'sales-changi-submissions',
        icon: 'FileTextIcon',
        resource: 'ChangiSalesSubmission',
        action: 'read',
        parent: 'sales',
      },
    ],
  },
]
